import React from "react";

const compatibiltyInfoData = [
  {
    icon: "/assets/imei-icon.svg",
    altText: "IMEI",
    title: "Easy Ways to Find Your IMEI",
    description:
      "Your IMEI is like your phone's ID number. Here's how to find it:",
    steps: [
      "Dial *#06# on your phone",
      "Check Settings > About Phone",
      "Look on your phone's box",
    ],
  },
  {
    icon: "/assets/mobile-icon.svg",
    altText: "Mobile",
    title: "What Makes a Phone Compatible?",
    description: "Your phone will work great with VLE Mobile if it's:",
    steps: [
      "Unlocked (not tied to another carrier)",
      "A 4G or 5G phone",
      "Preferably made in the last 5 years",
    ],
  },
  {
    icon: "/assets/arrow-swap-horizontal.svg",
    altText: "Arrow Swap Horizontal",
    title: "Switching is Super Easy!",
    description: "Once your phone is compatible:",
    steps: [
      "Keep your current number",
      "Get your SIM/eSIM today",
      "Start saving immediately",
    ],
  },
];

export const CompatibiltyInfo = () => {
  return (
    <section
      id="how-to-find-your-imei"
      className="px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12"
    >
      <div className="bg-[#F7F7F7] w-full max-w-[92.1875rem] p-6 sm:p-8 md:p-12 lg:p-16 xl:p-20 2xl:p-[6.625rem] pb-3 sm:pb-4 md:pb-6 lg:pb-8 xl:pb-10 2xl:pb-[3.3125rem] rounded-[2rem] sm:rounded-[2.25rem] md:rounded-[2.5rem] lg:rounded-[2.75rem] xl:rounded-[3rem] 2xl:rounded-[3.25rem] mx-auto">
        <ul className="grid gap-5 sm:grid-cols-2 2xl:grid-cols-3 sm:gap-6 md:gap-8 lg:gap-10 2xl:gap-12">
          {compatibiltyInfoData.map((item, index) => (
            <li
              key={index}
              className="flex flex-col w-full 2xl:max-w-[24.3125rem] bg-white p-5 sm:p-6 md:p-7 lg:p-8 border border-[#E5E7EB] rounded-xl md:rounded-2xl"
            >
              <div className="flex items-center justify-center bg-[#FFFAF6] size-[4.25rem] sm:size-[4.5rem] md:size-[4.75rem] lg:size-20 rounded-xl md:rounded-2xl mb-4 sm:mb-5 lg:mb-6">
                <img
                  src={item.icon}
                  alt={item.altText}
                  className="size-9 sm:size-10 md:size-11 lg:size-12"
                />
              </div>
              <h4 className="font-mobile text-[#202632] text-base sm:text-lg md:text-xl lg:text-[1.418rem] font-bold leading-5 sm:leading-6 md:leading-7 lg:leading-8 mb-3.5 sm:mb-4 lg:mb-5">
                {item.title}
              </h4>
              <p className="flex-1 text-[#808999] text-[0.825rem] sm:text-sm lg:text-[0.92969rem] font-normal leading-[1.125rem] sm:leading-5 lg:leading-[1.625rem] mb-5 sm:mb-6 md:mb-7 lg:mb-8">
                {item.description}
              </p>
              {index === 0 ? (
                <ol className="space-y-1 sm:space-y-1.5 lg:space-y-2 list-decimal pl-3.5 sm:pl-4 lg:pl-[1.125rem]">
                  {item.steps.map((step, index) => (
                    <li
                      key={index}
                      className="text-[#808999] text-[0.825rem] sm:text-sm lg:text-[0.92969rem] font-normal leading-4 sm:leading-5 lg:leading-[1.625rem] sm:-indent-0.5"
                    >
                      {step}
                    </li>
                  ))}
                </ol>
              ) : (
                <ul className="space-y-1 sm:space-y-1.5 lg:space-y-2 list-disc pl-3.5 sm:pl-4 lg:pl-[1.125rem]">
                  {item.steps.map((step, index) => (
                    <li
                      key={index}
                      className="text-[#808999] text-[0.825rem] sm:text-sm lg:text-[0.92969rem] font-normal leading-[1.125rem] sm:leading-5 lg:leading-[1.625rem] sm:-indent-0.5"
                    >
                      {step}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
        <p className="text-center text-[#1D1D1B] text-sm md:text-base lg:text-lg font-medium leading-[1.125rem] sm:leading-5 lg:leading-[1.375rem] mt-3 sm:mt-4 md:mt-5 lg:mt-7 xl:mt-10">
          Not sure if your phone is unlocked?{" "}
          <a
            href="https://vlecdn.b-cdn.net/unlocking-guide.html "
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-[#E44501] underline underline-offset-2"
          >
            Click here to learn more
          </a>
        </p>
      </div>
    </section>
  );
};
